const AcademiaCardBadge = ({
  badgeTxt,
  additionalClassNames,
}: {
  badgeTxt: string;
  additionalClassNames: string;
}) => {
  // rendering academia card badge component here
  return (
    <div className='flex items-center justify-end'>
      <div className='relative mb-2'>
        <div
          className={`relative text-sm capitalize italic font-semibold px-5 py-1 rounded-md z-10 bg-transparent border-2 ${additionalClassNames}`}
        >
          <p>{badgeTxt}</p>
        </div>
      </div>
    </div>
  );
};

export default AcademiaCardBadge;
